<soft-page>
  <div [softScrollIntoView]="true" scrollBehavior="instant"></div>

  @if ((loading$ | async) === false) {
    <ng-container>
      <div class="text-2xl font-bold mt-3 mb-4">
        {{ '#WWS_WARENUEBERNAHME.DETAIL.TITEL_WARENUEBERNAHME' | translate }}
      </div>
      @if (warenuebernahme$ | async; as warenuebernahme) {
        <soft-kopfdaten [warenuebernahme]="warenuebernahme"></soft-kopfdaten>
        @if (warenuebernahmeBewegung$ | async; as bewegung) {
          @if (config.lagerplatzauswahl) {
            <div class="flex flex-col xs:flex-row xs:justify-between mt-4">
              <div class="flex flex-col justify-center w-full">
                <div class="font-bold text-sm soft-overline">
                  {{ '#WWS_WARENUEBERNAHME.DETAIL.TITEL_LAGERPLATZ_AUSWAHL' | translate }}
                </div>
              </div>
              <div class="flex w-full xs:items-end xs:justify-end">
                @if ((lagerplatzAuswahlLagerplaetze()?.length ?? 0) > 0) {
                  <soft-select
                    #selectFilter
                    [value]="selectedLagerplatzAuswahl()"
                    (valueChange)="selectedLagerplatzChanged(warenuebernahme, $event)"
                    class="h-full border border-primary-400 p-2 xs:w-48 lg:w-1/2"
                  >
                    @for (
                      lagerplatz of lagerplatzAuswahlLagerplaetze();
                      track lagerplatz
                    ) {
                      <soft-select-option [value]="lagerplatz">
                        {{ lagerplatz.lagerplatz }}
                      </soft-select-option>
                    }
                  </soft-select>
                } @else {
                  <div class="text-lighter text-sm italic">
                    Es wurden keine Lagerplätze gefunden...
                  </div>
                }
              </div>
            </div>
          }
          <div class="flex flex-row justify-between mt-4">
            <div class="flex flex-col w-full">
              <div class="font-bold text-sm soft-overline">
                {{ '#WWS_WARENUEBERNAHME.DETAIL.TITEL_POSITIONEN' | translate }}
              </div>
              <div class="text-lighter text-sm">
                {{ bewegung?.offeneBewegungen?.length }}
                {{ '#WWS_WARENUEBERNAHME.DETAIL.LABEL_OFFEN' | translate }} /
                {{ bewegung?.erledigteBewegungen?.length }}
                {{ '#WWS_WARENUEBERNAHME.DETAIL.LABEL_ERLEDIGT' | translate }}
              </div>
            </div>
            <div class="flex w-full items-end justify-end">
              <soft-select
                #selectFilter
                [value]="visibleStatus$ | async"
                (valueChange)="visibleStatus$.next($event ?? filterValues[0])"
                class="h-full border border-primary-400 p-2 w-48 lg:w-1/2"
              >
                @for (filterOption of filterValues; track filterOption) {
                  <soft-select-option [value]="filterOption">
                    {{ filterOption.bezeichnung | translate }}
                  </soft-select-option>
                }
              </soft-select>
            </div>
          </div>
          <soft-bewegung-list
            [bewegungen]="(bewegungen$ | async) ?? []"
            [palletItems]="palletItemsForFilterState()"
            [hasReklamationPermission]="hasReklamationPermission()"
            (statusChange)="updateBeweStatus($event)"
            (beweLgStatusChange)="updateBeweLgStatus($event)"
            (mengeChange)="updateMengeLocal($event)"
            (mengenEingabeOeffnen)="openMengeDialog($event)"
            (bewelgMengeChange)="lademittelMengeChange($event)"
            (actionClick)="openActionDialog($event)"
            (lagerplatzChange)="onBeweLagerplatzChange($event)"
            (beweLgLagerplatzChange)="onBeweLgLagerplatzChange($event)"
          />
          <button
            type="button"
            class="soft-button secondary w-full h-12.5 mt-4 mb-3 rounded-sm"
            (click)="openEmballageHinzufuegenDialog()"
          >
            <span class="mr-2">+</span>
            {{ '#WWS_WARENUEBERNAHME.DETAIL.LABEL_EMBALLAGEN_HINZUFUEGEN' | translate }}
          </button>
        }
      }
    </ng-container>
  } @else {
    <div class="flex flex-col w-full mt-4">
      <div class="skeleton rounded h-8 w-48 mb-3"></div>
      <div class="skeleton rounded h-5 w-16 mb-2"></div>
      <div class="skeleton rounded h-39.25 w-full mb-3"></div>
      <div class="flex flex-row w-full justify-between">
        <div class="flex flex-col w-auto">
          <div class="skeleton rounded h-4.5 w-24 mb-2" *softRepeat="2"></div>
        </div>
        <div class="flex flex-col w-auto">
          <div class="skeleton rounded h-11 w-48 mb-2"></div>
        </div>
      </div>
      <div class="skeleton rounded h-42.5 w-full mb-3" *softRepeat="5"></div>
    </div>
  }

  @if (abschliessenLoading() || palettenService.isLoading()) {
    <soft-blocking-loading-spinner />
  }
</soft-page>

<ng-template #actionBar />
